import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Loader from "../child/Loder";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "../child/Alert/DengerAlert";
import {
  fetchInteractionById,
  fetchVaultUnlockDetails,
} from "../services/matchService"; // 🔹 create this API service like your others
import moment from "moment";
import ChatMessagesTable from "../ChatList/ChatList";

// One side's chat id for the conversation viewer. The pair record carries
// userA/userB; fromUser/toUser were read here first and are missing on it,
// which sent "cm_undefined" for both sides (2026-09-26). No id at all
// leaves it empty, and the viewer says no conversation is selected.
const chatUidOf = (...sides) => {
  for (const side of sides) {
    const id = side && typeof side === "object" ? side._id : side;
    if (id) return `cm_${id}`;
  }
  return undefined;
};

const ViewMatchPageNew = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("match-status");
  const [matchData, setMatchData] = useState(null);
  const [vaultData, setVaultData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");




  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // 1️⃣ Fetch Match Details
        const matchRes = await fetchInteractionById(id);
        if (matchRes?.data?.status === 1) {
          const match = matchRes.data.data;
          setMatchData(match);

          // 2️⃣ Only fetch Vault details if both user IDs exist
          const fromUserId = match?.fromUser?._id;
          const toUserId = match?.toUser?._id;

          if (fromUserId && toUserId) {
            const vaultRes = await fetchVaultUnlockDetails(
              fromUserId,
              toUserId
            );
            if (vaultRes?.data?.status === 1) {
              setVaultData(vaultRes.data.data);
            } else {
              setErrorMessage(
                vaultRes?.data?.message || "Failed to fetch vault details"
              );
            }
          }
        } else {
          setErrorMessage(
            matchRes?.data?.message || "Failed to fetch interaction"
          );
        }
      } catch (err) {
        setErrorMessage(err?.message || "Server error");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const session = vaultData?.revealTogetherSession;

  // Reveal Together is unlocked if:
  // - Both users confirmed, OR
  // - Admin triggered the session (initiatedBy is admin)
  const isRevealTogetherUnlocked =
    session &&
    ((session.userAConfirmed && session.userBConfirmed) ||
      (session.initiatedBy && session.initiatedBy === "adminId")); // replace with admin check
  const initiatedById = session && session?.initiatedBy.toString();
  const userId = vaultData?.user.id;
  const matchedUserId = vaultData?.matchedUser.id;

  if (loading) return <Loader />;

  return (
    <div className="row gy-4">
      <div className="col-lg-12">
        {successMessage && (
          <SuccessAlert
            message={successMessage}
            onClose={() => setSuccessMessage("")}
          />
        )}
        {errorMessage && (
          <DengerAlert
            message={errorMessage}
            onClose={() => setErrorMessage("")}
          />
        )}
      </div>

      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            {/* Tab Navigation */}
            <ul
              className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
              id="match-discovery-tab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link d-flex align-items-center px-24 ${activeTab === "match-status" ? "active" : ""
                    }`}
                  id="tab-match-status"
                  type="button"
                  role="tab"
                  onClick={() => setActiveTab("match-status")}
                >
                  Match Status
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link d-flex align-items-center px-24 ${activeTab === "vault-unlock" ? "active" : ""
                    }`}
                  id="tab-vault-unlock"
                  type="button"
                  role="tab"
                  onClick={() => setActiveTab("vault-unlock")}
                >
                  Vault Unlock
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link d-flex align-items-center px-24 ${activeTab === "chat" ? "active" : ""
                    }`}
                  id="chat"
                  type="button"
                  role="tab"
                  onClick={() => setActiveTab("chat")}
                >
                  Chat
                </button>
              </li>
            </ul>

            {/* Tab Content */}
            <div className="tab-content" id="match-discovery-tab-content">
              {/* Match Status Tab */}
              {activeTab === "match-status" && matchData && (
                <div
                  className="tab-pane fade show active"
                  id="tab-content-match-status"
                  role="tabpanel"
                >
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold">From User:</label>
                      <div>
                        {matchData?.fromUser?.email ||
                          matchData?.fromUser?.fullName ||
                          "N/A"}
                      </div>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold">To User:</label>
                      <div>
                        {matchData?.toUser?.email ||
                          matchData?.toUser?.fullName ||
                          "N/A"}
                      </div>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold">Action:</label>
                      <div>
                        {matchData?.action
                          ? matchData.action
                            .replace(/_/g, " ")
                            .replace(/\b\w/g, (l) => l.toUpperCase())
                          : "N/A"}
                      </div>
                    </div>

                    {matchData?.action === "super_curiouzz" ? (
                      <div className="col-md-4 mb-3">
                        <label className="form-label fw-bold">
                          Unique Question:
                        </label>
                        <div>{matchData?.questionId?.questionText}</div>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold">Status:</label>
                      <div>
                        {matchData?.status
                          ? matchData.status.charAt(0).toUpperCase() +
                          matchData.status.slice(1)
                          : "N/A"}
                      </div>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold">Match Score:</label>
                      <div>
                        {matchData?.commonAvg
                          ? `${matchData?.commonAvg}%`
                          : "N/A"}
                      </div>
                    </div>


                    {/* Unmatched info */}
                    {matchData?.status === "unmatched" &&
                      matchData?.unmatchedBy && (
                        <>
                          <div className="col-md-4 mb-3">
                            <label className="form-label fw-bold">
                              Unmatched By:
                            </label>
                            <div>
                              {matchData.unmatchedBy?.email ||
                                matchData.unmatchedBy?.fullName ||
                                "N/A"}
                            </div>
                          </div>
                          <div className="col-md-4 mb-3">
                            <label className="form-label fw-bold">
                              Unmatched At:
                            </label>
                            <div>
                              {matchData.unmatchedAt
                                ? moment(matchData.unmatchedAt).format(
                                  "DD-MM-YYYY"
                                )
                                : "N/A"}
                            </div>
                          </div>
                        </>
                      )}

                    {matchData?.overrideBy && (
                      <>
                        <div className="col-md-4 mb-3">
                          <label className="form-label fw-bold">
                            Updated By:
                          </label>
                          <div>{matchData.overrideBy?.name || "N/A"}</div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="form-label fw-bold">
                            Designation:
                          </label>
                          <div>{matchData.overrideBy?.role || "N/A"}</div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="form-label fw-bold">Email:</label>
                          <div>{matchData.overrideBy?.email || "N/A"}</div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="form-label fw-bold">Reason:</label>
                          <div>{matchData?.reason || "N/A"}</div>
                        </div>
                      </>
                    )}
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold">Created At:</label>
                      <div>
                        {matchData?.createdAt
                          ? moment(matchData.createdAt).format("DD-MM-YYYY")
                          : "N/A"}
                      </div>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold">Replied At:</label>
                      <div>
                        {matchData?.repliedAt
                          ? moment(matchData.repliedAt).format("DD-MM-YYYY")
                          : "N/A"}
                      </div>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold">Updated At:</label>
                      <div>
                        {matchData?.overrideAt
                          ? moment(matchData.overrideAt).format("DD-MM-YYYY")
                          : "N/A"}
                      </div>
                    </div>
                  </div>
                </div>
              )}{" "}
              {/* Vault Unlock Tab */}

              {activeTab === "vault-unlock" && vaultData && (
                <div
                  className="tab-pane fade show active"
                  id="tab-content-vault-unlock"
                >
                  {/* REVEAL STATUS */}
                  <div className="row mb-4">
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold">User:</label>
                      <div>
                        {vaultData.user.fullName} ({vaultData.user.email})
                      </div>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold">
                        Matched With:
                      </label>
                      <div>
                        {vaultData.matchedUser.fullName} (
                        {vaultData.matchedUser.email})
                      </div>
                    </div>

                    <div className="col-md-4">
                      <label className="form-label fw-bold">
                        Reveal Together Unlocked:
                      </label>
                      {/* <div
                        className={
                          vaultData.revealTogetherUnlocked
                            ? "text-success"
                            : "text-danger"
                        }
                      >
                        {vaultData.revealTogetherUnlocked
                          ? "Yes (Admin Unlocked)"
                          : "No"}
                      </div> */}
                      <div
                        className={
                          isRevealTogetherUnlocked ? "text-success" : "text-danger"
                        }
                      >
                        {isRevealTogetherUnlocked
                          ? "Yes"
                          : "No"}
                      </div>
                    </div>


                  </div>

                  {/* PROGRESS TABLE */}
                  <label className="form-label fw-bold mb-2">
                    Tier Progress (Both Users)
                  </label>

                  <div className="card mb-4 shadow-sm">
                    <div className="card-body p-0">
                      <div className="table-responsive">
                        <table className="table table-bordered align-middle mb-0">
                          <thead className="table-light">
                            <tr>
                              <th>Tier</th>
                              <th>{vaultData.user.fullName} Progress</th>
                              <th>{vaultData.matchedUser.fullName} Progress</th>
                              <th>Both Completed</th>
                              <th>Admin Unlock</th>
                            </tr>
                          </thead>

                          <tbody>
                            {vaultData.tierDetails?.map((tier, index) => (
                              <tr key={index}>
                                <td>
                                  <strong>{tier.tier}</strong>
                                  <br />
                                  <small className="text-muted">
                                    {tier.subText}
                                  </small>
                                </td>

                                {/* USER PROGRESS */}
                                <td>
                                  {tier.userProgress.currentStep}/
                                  {tier.totalSteps} (
                                  {tier.userProgress.progressPercent.toFixed(0)}
                                  %)
                                </td>

                                {/* MATCHED USER PROGRESS */}
                                <td>
                                  {tier.matchedUserProgress.currentStep}/
                                  {tier.totalSteps} (
                                  {tier.matchedUserProgress.progressPercent.toFixed(
                                    0
                                  )}
                                  %)
                                </td>

                                {/* BOTH COMPLETED */}
                                <td>
                                  {tier.bothCompleted ? (
                                    <span className="badge bg-success">
                                      Yes
                                    </span>
                                  ) : (
                                    <span className="badge bg-secondary">
                                      No
                                    </span>
                                  )}
                                </td>

                                {/* ADMIN UNLOCK */}
                                <td>
                                  {tier.unlockedByAdmin ? (
                                    <span className="badge bg-warning text-dark">
                                      Yes
                                    </span>
                                  ) : (
                                    "N/A"
                                  )}
                                </td>

                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>


                  {/* REVEAL TOGETHER SESSION TABLE */}
                  {vaultData.revealTogetherSession && (
                    <>
                      <label className="form-label fw-bold mt-4">
                        Reveal Together
                      </label>
                      <div className="card shadow-sm mb-4">
                        <div className="card-body p-0">
                          <div className="table-responsive">
                            <table className="table table-bordered align-middle mb-0">
                              <thead className="table-light">
                                <tr>
                                  {/* <th>Session ID</th> */}
                                  <th>User</th>
                                  <th>User</th>
                                  {/* <th>User A Confirmed</th>
                                  <th>User B Confirmed</th> */}
                                  <th>Initiated By</th>
                                  <th>Start Time</th>
                                  <th>Expires At</th>
                                  <th>Status</th>
                                  <th>Reignite Count</th>
                                  <th>Closed Reason</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  {/* <td>{vaultData.revealTogetherSession._id}</td> */}
                                  <td>
                                    {vaultData.revealTogetherSession.userA.toString() === vaultData.user.id
                                      ? vaultData.user.fullName
                                      : vaultData.matchedUser.fullName}
                                    <br />
                                    {vaultData.revealTogetherSession.userAConfirmed ? (
                                      <span className="badge bg-success">Yes</span>
                                    ) : (
                                      <span className="badge bg-secondary">No</span>
                                    )}
                                  </td>
                                  <td>
                                    {vaultData.revealTogetherSession.userB.toString() === vaultData.user.id
                                      ? vaultData.user.fullName
                                      : vaultData.matchedUser.fullName}
                                    <br />
                                    {vaultData.revealTogetherSession.userBConfirmed ? (
                                      <span className="badge bg-success">Yes</span>
                                    ) : (
                                      <span className="badge bg-secondary">No</span>
                                    )}
                                  </td>


                                  <td>
                                    {initiatedById === userId
                                      ? vaultData.user.fullName
                                      : initiatedById === matchedUserId
                                        ? vaultData.matchedUser.fullName
                                        : "Admin"}
                                  </td>
                                  <td>{moment(vaultData.revealTogetherSession.startTime).format("DD-MM-YYYY HH:mm")}</td>
                                  <td>{moment(vaultData.revealTogetherSession.expiresAt).format("DD-MM-YYYY HH:mm")}</td>
                                  <td>{vaultData.revealTogetherSession.status}</td>
                                  <td>{vaultData.revealTogetherSession.reigniteCount}</td>
                                  <td>{vaultData.revealTogetherSession.closedReason || "N/A"}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </>
                  )}


                  {/* ADMIN ACTION LOG */}
                  <label className="form-label fw-bold">
                    Admin Actions Log
                  </label>

                  {vaultData.adminGlobalActions.length > 0 ||
                    vaultData.tierDetails.some(
                      (t) => t.adminActions.length > 0
                    ) ? (
                    <div className="card shadow-sm">
                      <div className="card-body p-0">
                        <div className="table-responsive">
                          <table className="table table-bordered align-middle mb-0">
                            <thead className="table-light">
                              <tr>
                                <th>Admin</th>
                                <th>Email</th>
                                <th>Tier</th>
                                <th>Type</th>
                                <th>Reason</th>
                                <th>Permanent</th>
                                <th>Date</th>
                              </tr>
                            </thead>

                            <tbody>
                              {/* Tier-specific actions */}
                              {vaultData.tierDetails.flatMap((tier) =>
                                tier.adminActions.map((log, idx) => (
                                  <tr key={idx}>
                                    <td>{log.adminName}</td>
                                    <td>{log.adminEmail}</td>
                                    <td>{tier.tier}</td>
                                    <td>Tier Unlock</td>
                                    <td>{log.reason}</td>
                                    <td>{log.permanent ? "Yes" : "No"}</td>
                                    <td>
                                      {moment(log.date).format("DD-MM-YYYY")}
                                    </td>
                                  </tr>
                                ))
                              )}

                              {/* GLOBAL actions */}
                              {vaultData.adminGlobalActions.map((log, idx) => (
                                <tr key={idx}>
                                  <td>{log.adminName}</td>
                                  <td>{log.adminEmail}</td>
                                  <td>All Tiers</td>
                                  <td>{log.unlockType}</td>
                                  <td>{log.reason}</td>
                                  <td>N/A</td>
                                  <td>
                                    {moment(log.date).format("DD-MM-YYYY")}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <p className="text-muted">No admin actions recorded.</p>
                  )}
                </div>
              )}

         

              {activeTab === "chat" && (
                <ChatMessagesTable
                  defaultUid={chatUidOf(matchData.fromUser, matchData.userA)}
                  defaultOtherUser={chatUidOf(matchData.toUser, matchData.userB)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewMatchPageNew;
